import { t } from 'i18next'
import { SetStateAction, useContext, useEffect, useState } from 'react'
import parentFormDataContext from '../../../contexts/ParentFormDataContext'
import { IPolicyResponse } from '../../../model/IPolicyReponse'
import ErrMessageSummary from '../../errMessageSummary/ErrMessageSummary'
import PolicyReceipt from '../policyReceipt/policyReceipt'
import PaymentInformation from '../premiumPayment/PaymentInformation'
import SelectedPremiums from '../premiumPayment/SelectedPremiums'
import ParentConfirmation from './ParentConfirmation'
export interface IConfirmation {
    className?: string
    setShowConfirmation: React.Dispatch<SetStateAction<boolean>>
}

const Confirmation: React.FC<IConfirmation> = ({
    className,
    setShowConfirmation,
}) => {
    const { parentFormData, setParentFormData } = useContext(parentFormDataContext)
    const [showReceipt, setShowReceipt] = useState<boolean>(false)
    const [policyResponse, setPolicyResponse] = useState<IPolicyResponse>({} as IPolicyResponse)

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    return (
        <div className='bg-[#f5f5f5]'>
            {!showReceipt ? (<>
                <div className="bg-[#0082ca] h-auto items-center flex flex-col space-y-2 mt-2.5 py-5">
                    <h1 className="text-center text-black lg:text-xl text-lg font-semibold lg:w-[53rem] md:w-[31rem] w-[19rem]">
                        {t('confirmAndPay')}
                    </h1>
                    <p className="text-black text-center font-normal lg:text-lg text-base lg:w-[53rem] md:w-[30rem] w-[19rem]">
                        {t('verifyAndproceedText')}
                    </p>
                </div>
                {parentFormData.QuoteErrorMessages.length > 0 && <ErrMessageSummary setShowConfirmation={setShowConfirmation} />}
                <ParentConfirmation className="pt-4" />
                <SelectedPremiums setShowConfirmation={setShowConfirmation} />
                {parentFormData.QuoteErrorMessages.length === 0 && <PaymentInformation setShowConfirmation={setShowConfirmation} setShowReceipt={setShowReceipt} setPolicyResponse={setPolicyResponse} />}
            </>)
                : (
                    <PolicyReceipt policyResponse={policyResponse}
                        setShowConfirmation={setShowConfirmation} />
                )}
        </div>
    )
}

export default Confirmation
